import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './style.css';
import CreateEventAdmin from './CreateEventAdmin';
import AdminEventList from './AdminEventList';
import PhotographerList from './PhotographerList';
import UserLogs from './UserLogs';
import EventAnalytics from './EventAnalytics';
import SizeContext from 'antd/es/config-provider/SizeContext';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [activeView, setActiveView] = useState('create');

  useEffect(() => {
    const auth = localStorage.getItem('user');
    if (!auth) {
      navigate('/login');
      return;
    }

    const user = JSON.parse(auth);
    if (user.role !== 'admin') {
      alert('Unauthorized access');
      navigate('/');
      return;
    }

    setUsername(user);

    const link = document.createElement('link');
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js';
    script.integrity = 'sha384-C6RzsynM9kWDrMNeT87bh95OGNyZPhcTNXj1NW7RuBCsyN/o0jlpcV8Qyq46cDfL';
    script.crossOrigin = 'anonymous';

    link.href = 'https://cdn.lineicons.com/4.0/lineicons.css';
    link.rel = 'stylesheet';

    document.head.appendChild(link);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(link);
      document.head.removeChild(script);
    };
  }, []);

  const logout = () => {
  if (window.confirm("Are you sure you want to logout?")) {
    localStorage.clear();
    setTimeout(() => {
      navigate("/login");
    }, 100); // slight delay to ensure smooth navigation
  }
};




  return (
    <div className="wrapper">
      {/* Sidebar */}
      <aside id="sidebar" className="expand">
        <div className="d-flex">
          <button className="toggle-btn" type="button">
            <i className="lni lni-grid-alt"></i>
          </button>
          <div className="sidebar-logo">
            <a href="#" style={{ fontSize: "25px" }}>PicAura</a>
          </div>
        </div>
        <ul className="sidebar-nav">
          <li className="sidebar-item">
            <Link onClick={() => setActiveView('create')} className="sidebar-link">
              <i className="lni lni-save"></i>
              <span>Create Event</span>
            </Link>
          </li>
          <li className="sidebar-item">
            <Link onClick={() => setActiveView('events')} className="sidebar-link">
              <i className="lni lni-list"></i>
              <span>All Events</span>
            </Link>
          </li>
          <li className="sidebar-item">
            <Link onClick={() => setActiveView('photographers')} className="sidebar-link">
              <i className="lni lni-users"></i>
              <span>Photographers</span>
            </Link>
          </li>
          <li className="sidebar-item">
  <Link onClick={() => setActiveView('userlogs')} className="sidebar-link">
    <i className="lni lni-eye"></i>
    <span>User Access Logs</span>
  </Link>
</li>
          <li className="sidebar-item">
            <Link onClick={() => setActiveView('analytics')} className="sidebar-link">
              <i className="lni lni-bar-chart"></i>
              <span>Analytics</span>
            </Link>
          </li>
        </ul>
        <div className="sidebar-footer">
                  <Link onClick={logout} className="sidebar-link">
                    <i className="lni lni-exit"></i>
                    <span>Logout</span>
                  </Link>
                </div>

      </aside>

      {/* Main Area */}
      <div className="main">
        <nav className="navbar navbar-expand px-4 py-3">
          <div className="navbar-collapse collapse">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item dropdown px-3">
                <a href="#" data-bs-toggle="dropdown" className="nav-icon pe-md-0">
  <h4>Admin: {username.name}</h4>
</a>
<div className="dropdown-menu dropdown-menu-end rounded">
  <button onClick={logout} className="dropdown-item" style={{ background: 'none', border: 'none', width: '100%', textAlign: 'left' }}>
    <i className="lni lni-exit"></i>
    <span>Logout</span>
  </button>
</div>


              </li>
            </ul>
          </div>
        </nav>

        <main className="px-3 py-4">
          <div className="container-fluid">
            {activeView === 'create' && <CreateEventAdmin />}
            {activeView === 'events' && <AdminEventList />}
            {activeView === 'photographers' && <PhotographerList />}
            {activeView === 'userlogs' && <UserLogs />}
            {activeView === 'analytics' && <EventAnalytics />}
          </div>
        </main>

        <div className="row text-body-secondary footer">
          <div className="col-12">
            <h5>Designed by Three Musketeers Infotech (Neha & Shraddha)</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
